export type TEnvironment = 'prod' | 'stg' | 'dev' | 'unknown'

export interface ICheckEnvironmentResult {
  environment: TEnvironment
  isStg: boolean
  isProd: boolean
}

const detectEnvironment = (ownerId: string): TEnvironment => {
  if (ownerId.includes('-prod')) {
    return 'prod'
  }
  if (ownerId.includes('-stg')) {
    return 'stg'
  }
  if (ownerId.includes('-dev')) {
    return 'dev'
  }

  return 'unknown'
}

/**
 * An owner id matching no marker is `unknown`, which is not the same decision as "not
 * production" even though it is the same boolean. Anything that routes users away from
 * the live surface must read `environment` and act on a positive match.
 */
export const checkEnvironment = (ownerId: string): ICheckEnvironmentResult => {
  const environment = detectEnvironment(ownerId)

  return {
    environment,
    isStg: environment === 'stg' || environment === 'dev',
    isProd: environment === 'prod',
  }
}
